import './simpleBadge.css';
import React from 'react';

interface SimpleBadgeProps {
    selected?: boolean;
    status?: string;
    text?: React.ReactNode;
    title?: React.ReactNode;
    onClick?: () => void;
    onRemove?: () => void;
}

export const SimpleBadge: React.FC<SimpleBadgeProps> = ({ selected = true, status = '', text, title = '', onClick = () => {}, onRemove }) => {
    return (
        <div
            className={`${selected ? 'selected' : ''} ${status} simpleBadge d-inline-block`}
            onClick={onClick}
        >
            <div style={{ marginRight: '10px' }}>
                {title !== '' ? (
                    <div>
                        <b>{title}</b>
                    </div>
                ) : (
                    <></>
                )}
                {text}
                {onRemove && (
                    <span
                        className="simpleBadge-remove"
                        onClick={(evt) => {
                            evt.stopPropagation();
                            onRemove();
                        }}
                    >
                        &times;
                    </span>
                )}
            </div>
        </div>
    );
};
